module.exports = __webpack_public_path__ + "img/372d32e.jpg";